import React from 'react';
import ContainerFlex from '~/components/containerFlex';
import Grid from '~/components/grid';
import Input, { MaskTypes } from '~/components/input';
import ToggleSwitch from '~/components/toggleSwitch';

import * as St from '../../style';
import Button from '~/components/button';
import { hourMinMask } from '~/utils/masks';

export interface IFormCampaingData {
  descCampanha: string;
  dtaValidade: string;
  dtaInicio: string;
  horaInicio: string;
  horaValidade: string;
  switchDtaExecucao: boolean;
}

export type TCampaingDataProps = {
  form: IFormCampaingData;
  setForm: React.Dispatch<React.SetStateAction<IFormCampaingData>>;
  isPreview?: boolean;
  isBtnSave?: boolean;
  onClickBtnSave?: (form: IFormCampaingData) => void;
  isManualTab?: boolean;
  onClickBtnCreateCampaign?: () => void;
  disabledBtnCreateCampaign?: boolean;
};

const CampaingData = ({
  form,
  setForm,
  isPreview = false,
  isBtnSave = true,
  onClickBtnSave,
  isManualTab = false,
  onClickBtnCreateCampaign,
  disabledBtnCreateCampaign = true,
}: TCampaingDataProps): JSX.Element => {
  return (
    <>
      <ContainerFlex>
        <Input
          label="Descrição da campanha"
          value={form.descCampanha}
          maxLength={150}
          onChange={(e) => {
            return setForm({
              ...form,
              descCampanha: e.target.value,
            });
          }}
        />
      </ContainerFlex>
      <Grid xs={1} lg={2} xl={5} gap={30} style={{ marginTop: '2%' }}>
        <ContainerFlex>
          <St.SpanSwitch>Data de agendamento</St.SpanSwitch>
          <ToggleSwitch
            id="switchDtaExecucao"
            toggled={form.switchDtaExecucao}
            onChangeFunction={() => {
              return setForm({
                ...form,
                switchDtaExecucao: !form.switchDtaExecucao,
              });
            }}
            widthSwitchLabel={45}
            disabled={isPreview}
          />
        </ContainerFlex>
        {form.switchDtaExecucao ? (
          <>
            <ContainerFlex>
              <Input
                label="Data execução agendamento"
                placeholder="DD/MM/YYYY"
                value={form.dtaInicio}
                maxLength={10}
                onChange={(e) => {
                  return setForm({
                    ...form,
                    dtaInicio: e.target.value.masked,
                  });
                }}
                mask={MaskTypes.DATE}
              />
            </ContainerFlex>
            <ContainerFlex>
              <Input
                label="Hora execução agendamento"
                placeholder="HH:MM"
                value={form.horaInicio}
                maxLength={5}
                onChange={(e) => {
                  return setForm({
                    ...form,
                    horaInicio: hourMinMask(e.target.value).masked,
                  });
                }}
              />
            </ContainerFlex>
          </>
        ) : (
          <>
            <ContainerFlex>
              <Input
                label="Data de validade"
                placeholder="DD/MM/YYYY"
                value={form.dtaValidade}
                maxLength={10}
                onChange={(e) => {
                  return setForm({
                    ...form,
                    dtaValidade: e.target.value.masked,
                  });
                }}
                mask={MaskTypes.DATE}
              />
            </ContainerFlex>
            <ContainerFlex>
              <Input
                label="Hora de validade"
                placeholder="HH:MM"
                value={form.horaValidade}
                maxLength={5}
                onChange={(e) => {
                  return setForm({
                    ...form,
                    horaValidade: hourMinMask(e.target.value).masked,
                  });
                }}
              />
            </ContainerFlex>
          </>
        )}
        {isPreview && isBtnSave && (
          <Button
            borderRadius={10}
            fitContent
            onClick={() => {
              if (onClickBtnSave) {
                onClickBtnSave(form);
              }
            }}
          >
            <span>Salvar</span>
          </Button>
        )}

        {isManualTab && !isPreview && (
          <Button
            borderRadius={10}
            fitContent
            onClick={() => {
              if (onClickBtnCreateCampaign) {
                onClickBtnCreateCampaign();
              }
            }}
            disabled={disabledBtnCreateCampaign}
          >
            <span>Criar campanha</span>
          </Button>
        )}
      </Grid>
    </>
  );
};

export default CampaingData;
